import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import AgentCard from "../components/AgentCard";
import { db } from "../services/firebase";

function AgentsPage({ user }) {
  const navigate = useNavigate();
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadAgents = async () => {
      if (!user?.uid) {
        setAgents([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError("");
      try {
        const apiQuery = query(collection(db, "users", user.uid, "apis"), orderBy("updatedAt", "desc"));
        const snapshot = await getDocs(apiQuery);
        setAgents(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (err) {
        setError(err.message || "Failed to load agents from Firestore.");
      } finally {
        setLoading(false);
      }
    };

    loadAgents();
  }, [user?.uid]);

  return (
    <div className="grid" style={{ gap: "16px" }}>
      <div className="section-header">
        <h2 className="section-header__title">Saved Agents</h2>
        <button className="button" onClick={() => navigate("/build-agent-dev")}>
          New Agent
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="grid grid--two">
        {loading && <p className="muted">Loading agents...</p>}
        {!loading && agents.length === 0 && <p className="muted">No agents saved yet.</p>}
        {!loading &&
          agents.map((agent) => (
            <AgentCard key={agent.id} agent={agent} onEdit={(agentId) => navigate(`/edit-agent/${agentId}`)} />
          ))}
      </div>
    </div>
  );
}

export default AgentsPage;
